import { Box, Container, styled } from "@mui/material";

export const PageMetaContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
`;

export const Page = styled(Container)`
  padding-block-start: 20px;
  width: 100%;
  height: 100%;
`;

export const PageHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ActionsWrapper = styled(Box)`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    justify-content: flex-end;

    &:not(:has(> :only-child)) {
      width: 100%;
      align-self: stretch;

      & > * {
        flex: 1 1 0;
        min-width: 0;
      }
    }
  }
`;
